<nz-spin [nzSpinning]="isSpinning">
  <div class="sales-portal-container">
    <div class="turnover-detail">
      <div class="detail-setting-header">
        <nz-breadcrumb>
          <nz-breadcrumb-item (click)="navigate('/sales-portal/turnover')" style="cursor: pointer">Turnover
          </nz-breadcrumb-item>
          <nz-breadcrumb-item>Dealer Details</nz-breadcrumb-item>
        </nz-breadcrumb>
        <div class="title">Dealer Details</div>
        <div class="key-value-box">
          <div class="key-value-item">
            <div class="key">Dealer Code</div>
            <div class="value ml20">{{ detailInfo.dealerCode }}</div>
          </div>
          <div class="key-value-item">
            <div class="key">Dealer Name</div>
            <div class="value ml20">{{ detailInfo.dealerName }}</div>
          </div>
          <div class="key-value-item">
            <div class="key">Target Year</div>
            <div class="value ml20">{{ detailInfo.targetYear }}</div>
          </div>
        </div>
      </div>

      <div class="target-section-detail">
        <sp-circular-progress
          [text]="'Achievement Rate'"
          [progress]="salesPortalService.dealerTargetSummaryInfo.procurementAchievedRate"
          class="circle-progress"
        ></sp-circular-progress>
        <div class="center">
          <div class="still-to-go">
            <span class="key">Still to GO</span>
            <span
              class="value">{{ salesPortalService.formatThousands(salesPortalService.dealerTargetSummaryInfo.procurementStillToGo, true) }}
              <span class="unit">(AUD)</span></span>
          </div>
          <div class="card-item-row">
            <div class="card-item">
              <div class="header header-light"></div>
              <div class="content-key">YTD Target Turnover</div>
              <div
                class="content-value">{{ salesPortalService.formatThousands(salesPortalService.dealerTargetSummaryInfo.ytdProcurement, true) }}
                <span class="unit">(AUD)</span></div>
            </div>
            <div class="card-item">
              <div class="header"></div>
              <div class="content-key">In Warehouse Processing</div>
              <div
                class="content-value">{{ salesPortalService.formatThousands(salesPortalService.dealerTargetSummaryInfo.inWarehouseProcessingProcurement, true) }}
                <span class="unit">(AUD)</span></div>
            </div>
          </div>
          <div class="card-item-row">
            <div class="card-item">
              <div class="header header-dark"></div>
              <div class="content-key">YTD Actual Turnover</div>
              <div
                class="content-value">{{ salesPortalService.formatThousands(salesPortalService.dealerTargetSummaryInfo.actualProcurement, true) }}
                <span class="unit">(AUD)</span></div>
            </div>
            <div class="card-item">
              <div class="header"></div>
              <div class="content-key">Open</div>
              <div
                class="content-value">{{ salesPortalService.formatThousands(salesPortalService.dealerTargetSummaryInfo.openedProcurement, true) }}
                <span class="unit">(AUD)</span></div>
            </div>
          </div>
        </div>
        <div class="divider"></div>
        <div class="right">
          <div class="white-space"></div>
          <div class="card-item-row">
            <div class="card-item" style="height: 194px">
              <div class="header"></div>
              <div class="content-key">Turnover Target</div>
              <div
                class="content-value">{{ salesPortalService.formatThousands(salesPortalService.dealerTargetSummaryInfo.targetProcurement, true) }}
                <span class="unit">(AUD)</span></div>
            </div>
          </div>
        </div>
      </div>
      <div style="margin-top: 40px"></div>
      <div *ngFor="let data of detailInfo.targetClassificationList">
        <div class="table-title" *ngIf="detailInfo.classificationMethod === 'PRODUCT_GROUP'">Product
          Group: {{ data.productGroup }}
        </div>
        <div class="table-title" *ngIf="detailInfo.classificationMethod === 'CBF'">
          CBF: {{ data.cbf }} {{ data.description ? '(' + data.description + ')' : '' }}
        </div>
        <nz-table
          class="detail-table"
          [nzData]="data.targetConfigurationList"
          [nzFrontPagination]="false"
          nzTableLayout="fixed"
        >
          <thead>
          <tr>
            <th nzWidth="200px"></th>
            <th nzAlign="center" *ngIf="detailInfo.targetSplitMethod !== 'BY_YEAR'">Total</th>
            <th *ngFor="let data of salesPortalService.transposeTableData(data.targetConfigurationList).name"
                nzAlign="center"
            >
              {{ data }}
            </th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>Target. {{ detailInfo.targetYear }}</td>
            <td
              *ngIf="detailInfo.targetSplitMethod !== 'BY_YEAR'"
              nzAlign="center"
              nzEllipsis
              [title]=" salesPortalService.formatThousands(data.targetAmount, true)"
            >{{ salesPortalService.formatThousands(data.targetAmount, true) }}
            </td>
            <td
              *ngFor="let data of salesPortalService.transposeTableData(data.targetConfigurationList).targetAmount"
              nzAlign="center"
              nzEllipsis
            >
              <span
                [title]=" salesPortalService.formatThousands(data, true)"> {{ salesPortalService.formatThousands(data, true) }}</span>
            </td>
          </tr>
          <tr>
            <td>Actual. {{ detailInfo.targetYear }}</td>
            <td
              *ngIf="detailInfo.targetSplitMethod !== 'BY_YEAR'"
              nzAlign="center"
              nzEllipsis
              [title]="salesPortalService.formatThousands(data.actualAmount, true)"
            >{{ salesPortalService.formatThousands(data.actualAmount, true) }}
            </td>
            <td
              *ngFor="let data of salesPortalService.transposeTableData(data.targetConfigurationList).actualAmount"
              nzAlign="center"
              nzEllipsis
            >
              <span
                [title]="salesPortalService.formatThousands(data, true)"> {{ salesPortalService.formatThousands(data, true) }}</span>
            </td>
          </tr>
          <tr>
            <td>Act. {{ detailInfo.targetYear }} vs. Target. {{ detailInfo.targetYear }} %</td>
            <td
              *ngIf="detailInfo.targetSplitMethod !== 'BY_YEAR'"
              nzAlign="center"
              nzEllipsis
              [title]="salesPortalService.formatThousands(data.actualVsTarget, true) + '%'"
            >{{ salesPortalService.formatThousands(data.actualVsTarget, true) }}%
            </td>
            <td
              *ngFor="let data of salesPortalService.transposeTableData(data.targetConfigurationList).actualVsTarget"
              nzAlign="center"
              nzEllipsis
            >
              <span
                [title]="salesPortalService.formatThousands(data, true) + '%'">  {{ salesPortalService.formatThousands(data, true) }}
                %</span>
            </td>
          </tr>
          <tr>
            <td>Actual. {{ detailInfo.targetYear - 1 }}</td>
            <td
              *ngIf="detailInfo.targetSplitMethod !== 'BY_YEAR'"
              nzAlign="center"
              nzEllipsis
              [title]="salesPortalService.formatThousands(data.lastYearActualAmount, true)"
            >{{ salesPortalService.formatThousands(data.lastYearActualAmount, true) }}
            </td>
            <td
              *ngFor="let data of salesPortalService.transposeTableData(data.targetConfigurationList).lastYearActualAmount"
              nzAlign="center"
              nzEllipsis
            >
              <span
                [title]="salesPortalService.formatThousands(data, true)"> {{ salesPortalService.formatThousands(data, true) }}</span>
            </td>
          </tr>
          <tr>
            <td>Act. {{ detailInfo.targetYear }} vs. Act.  {{ detailInfo.targetYear - 1 }} %</td>
            <td
              *ngIf="detailInfo.targetSplitMethod !== 'BY_YEAR'"
              nzAlign="center"
              nzEllipsis
              [title]="salesPortalService.formatThousands(data.actualVsLastYear, true) + '%'"
            >{{ salesPortalService.formatThousands(data.actualVsLastYear, true) }}%
            <td
              *ngFor="let data of salesPortalService.transposeTableData(data.targetConfigurationList).actualVsLastYear"
              nzAlign="center"
              nzEllipsis
            >
              <span
                [title]=" salesPortalService.formatThousands(data, true) + '%'">{{ salesPortalService.formatThousands(data, true) }}
                %</span>
            </td>
          </tr>
          </tbody>
        </nz-table>
      </div>
    </div>
  </div>
</nz-spin>



